import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";

import { getCategoriesQuery } from "./queries";

const CategoryContext = createContext({});

export const useCategoryContext = () => useContext(CategoryContext);

// GET /settings/category is accessible to any authenticated user (ROLE_USER).
// Single load via a ref (and not via categoryList.length): the reference data can
// be empty (not seeded), and a length guard would re-fetch in a loop because
// setCategoryList([]) recreates a reference on each call.
export const CategoryProvider = ({ ...props }) => {
  const [categoryList, setCategoryList] = useState([]);
  const loadedRef = useRef(false);

  const categoryListGetter = useCallback(async () => {
    if (loadedRef.current) return;
    loadedRef.current = true;
    try {
      setCategoryList((await getCategoriesQuery()) || []);
    } catch (e) {
      loadedRef.current = false;
      console.error("categoryListGetter", e);
    }
  }, []);

  const values = useMemo(
    () => ({ categoryList, categoryListGetter }),
    [categoryList, categoryListGetter]
  );

  return <CategoryContext.Provider value={values} {...props} />;
};
